/** Aug-2026 (User-Wunsch) — DMS-Einstellungen (e-Archivsystem) einmalig laden & cachen. */
import api from "./api";

const DEFAULT_DMS_BASE = "https://de-pietsch.e-archivsystem.com/log_client.aspx";

let _cache = null;
export function getDmsSettings() {
    if (!_cache) {
        _cache = api.get("/dispo/dms-settings").then((r) => r.data || {}).catch(() => ({}));
    }
    return _cache;
}
export function invalidateDmsSettings() { _cache = null; }
export function dmsUrlForVin(baseUrl, vin) {
    const base = (baseUrl || "").trim() || DEFAULT_DMS_BASE;
    return `${base}${base.includes("?") ? "&" : "?"}crit1=${encodeURIComponent(vin || "")}`;
}
export { DEFAULT_DMS_BASE };
